import type { FC } from "react";
import type { PartnerData } from "src/http/api-types";
import { SECONDARY_COLOR_CAT_IDS } from "../../../constants";
import { StyledTeamInitial, StyledTeamLogo, StyledTeamLogoImage } from "./styled-components";

interface Props {
  className?: string;
  id?: number | undefined;
  partnerData?: Maybe<PartnerData>;
  text?: Maybe<string>;
}

/**
 * Logo Component for a Team Card that shows PartnerLogo Image or Fallback Initial UI
 */
export const TeamLogo: FC<Props> = ({ className, id, partnerData, text }) => {
  const { partnerLogoUrl, primaryColor, secondaryColor } = partnerData ?? {};
  // Some teams primary colors are incorrect and/or not presentationally effective - Use secondary in these scenarios
  const bgColor = id && SECONDARY_COLOR_CAT_IDS.has(id) ? secondaryColor : primaryColor;

  return (
    <StyledTeamLogo bgColor={bgColor} className={className}>
      {partnerLogoUrl ? (
        <StyledTeamLogoImage alt="" size={{ height: 44, width: 44 }} src={partnerLogoUrl} />
      ) : (
        <StyledTeamInitial>{text?.slice(0, 1)}</StyledTeamInitial>
      )}
    </StyledTeamLogo>
  );
};
